import { NgModule, SkipSelf, Optional } from "@angular/core";
import {
  FirebaseService,
  AuthService,
  CityService,
  VenueService,
  OrderService,
  DateService,
  AnalyticsService,
  AuthGuard
} from "./services";
import { RecipientService } from "./services/recipient.service";

@NgModule({
  imports: [],
  providers: [
    FirebaseService,
    AuthService,
    CityService,
    DateService,
    VenueService,
    OrderService,
    RecipientService,
    AuthGuard,
    AnalyticsService
  ],
  entryComponents: [],
  declarations: [],
  exports: []
})
export class CoreModule {
  // constructor(@Optional() @SkipSelf() core: CoreModule) {
  //   if (core) {
  //     throw new Error("You should import core module only in the root module");
  //   }
  // }
}
